module.exports = __webpack_public_path__ + "static/gallery1-2f0b93a3596c954b7e050e7d94053f15.jpg";